import React, { useState, useEffect, useRef } from "react";
import "./CreateRole.css";
import bin from "../../Assets/Images/CreateRole/Trash.png";

// redux toolkit
import { fetchRoleData } from "../../Redux/features/CreateRole/createRoleSlice";
import { useSelector, useDispatch } from "react-redux";

import search from "../../Assets/Images/CreateRole/Search.png";
import searchTwo from "../../Assets/Images/CreateRole/searchTwo.png";

import Swal from "sweetalert2";

import { API_BASE_URL } from "../../Config/Config";

// const data = [
//   {
//     screen_id: 12,
//     screen_name: "Employee Registration",
//     create: 1,
//     read: 1,
//     delete: 1,
//     sections: [
//       {
//         sec_id: 4,
//         sec_name: "Custom Fields",
//         update: 1,
//       },
//       {
//         sec_id: 3,
//         sec_name: "Job Detail",
//         update: 1,
//       },
//       {
//         sec_id: 2,
//         sec_name: "ADDRESSES",
//         update: 1,
//       },
//       {
//         sec_id: 1,
//         sec_name: "Personal Information",
//         update: 1,
//       },
//     ],
//   },
//   {
//     screen_id: 13,
//     screen_name: "Registration",
//     create: 1,
//     read: 1,
//     delete: 1,
//     sections: [
//       {
//         sec_id: 4,
//         sec_name: "Custom Fields",
//         update: 1,
//       },
//       {
//         sec_id: 3,
//         sec_name: "Job Detail",
//         update: 1,
//       },
//       {
//         sec_id: 2,
//         sec_name: "ADDRESSES",
//         update: 1,
//       },
//       {
//         sec_id: 1,
//         sec_name: "Personal Information",
//         update: 1,
//       },
//     ],
//   },
//   ,
//   {
//     screen_id: 3,
//     screen_name: "Client Branches",
//     sections: [
//       { sec_id: 1, sec_name: "Personal Information" },
//       { sec_id: 2, sec_name: "Addresses" },
//       { sec_id: 3, sec_name: "Job Detail" },
//       { sec_id: 4, sec_name: "Custom Fields" },
//     ],
//   },
//   {
//     screen_id: 4,
//     screen_name: "State Master",
//     sections: [
//       { sec_id: 1, sec_name: "Personal Information" },
//       { sec_id: 2, sec_name: "Addresses" },
//       { sec_id: 3, sec_name: "Job Detail" },
//       { sec_id: 4, sec_name: "Custom Fields" },
//     ],
//   },
// ];

function CreateRole(dataClient) {
  // console.log(dataClient.dataClient.client_schema_name[6][0].user_name);
  const [searchText, setSearchText] = useState("");
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [visibleSections, setVisibleSections] = useState({});

  // input field
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [active, setActive] = useState(0);

  // redux toolkit
  const { data, loading, error } = useSelector((state) => state.createRole);
  const dispatch = useDispatch();

  const dataTwo = [
    {
      screen_id: 12,
      screen_name: "Employee Registration",
      create: 1,
      read: 1,
      delete: 1,
      sections: [
        {
          sec_id: 4,
          sec_name: "Custom Fields",
          update: 1,
        },
        {
          sec_id: 3,
          sec_name: "Job Detail",
          update: 1,
        },
        {
          sec_id: 2,
          sec_name: "ADDRESSES",
          update: 1,
        },
        {
          sec_id: 1,
          sec_name: "Personal Information",
          update: 1,
        },
      ],
    },
    {
      screen_id: 13,
      screen_name: "Student Registration",
      create: 1,
      read: 1,
      delete: 1,
      sections: [
        {
          sec_id: 4,
          sec_name: "Custom Fields",
          update: 1,
        },
        {
          sec_id: 3,
          sec_name: "Job Detail",
          update: 1,
        },
        {
          sec_id: 2,
          sec_name: "ADDRESSES",
          update: 1,
        },
        {
          sec_id: 1,
          sec_name: "Personal Information",
          update: 1,
        },
      ],
    },
    {
      screen_id: 14,
      screen_name: "Car Registration",
      create: 1,
      read: 1,
      delete: 1,
      sections: [
        {
          sec_id: 4,
          sec_name: "Custom Fields",
          update: 1,
        },
        {
          sec_id: 3,
          sec_name: "Job Detail",
          update: 1,
        },
        {
          sec_id: 2,
          sec_name: "ADDRESSES",
          update: 1,
        },
        {
          sec_id: 1,
          sec_name: "Personal Information",
          update: 1,
        },
      ],
    },
    {
      screen_id: 15,
      screen_name: "Bike Registration",
      create: 1,
      read: 1,
      delete: 1,
      sections: [
        {
          sec_id: 4,
          sec_name: "Custom Fields",
          update: 1,
        },
        {
          sec_id: 3,
          sec_name: "Job Detail",
          update: 1,
        },
        {
          sec_id: 2,
          sec_name: "ADDRESSES",
          update: 1,
        },
        {
          sec_id: 1,
          sec_name: "Personal Information",
          update: 1,
        },
      ],
    },
    {
      screen_id: 12,
      screen_name: "Batch Registration",
      create: 1,
      read: 1,
      delete: 1,
      sections: [
        {
          sec_id: 4,
          sec_name: "Custom Fields",
          update: 1,
        },
        {
          sec_id: 3,
          sec_name: "Job Detail",
          update: 1,
        },
        {
          sec_id: 2,
          sec_name: "ADDRESSES",
          update: 1,
        },
        {
          sec_id: 1,
          sec_name: "Personal Information",
          update: 1,
        },
      ],
    },
  ];

  useEffect(() => {
    dispatch(fetchRoleData());
  }, [dispatch]);

  // -------------------------------------------------------

  function useOutsideAlerter(ref, onOutsideClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          onOutsideClick();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, onOutsideClick]);
  }

  const dropdownRef = useRef(null);
  useOutsideAlerter(dropdownRef, () => setDropdownVisible(false));

  // -------------------------------------------------------

  useEffect(() => {
    if (data !== null) {
      // console.log("CreateRole Data", data);
    }
  }, [data]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleSearch = () => {
    if (searchText.length > 0) {
      const filteredResults = data.filter((item) =>
        item.screen_name.toLowerCase().includes(searchText.toLowerCase())
      );
      setSearchResults(filteredResults);
      setDropdownVisible(true);
    }
  };

  const handleSelectItem = (item) => {
    if (
      !selectedScreens.some((screen) => screen.screen_id === item.screen_id)
    ) {
      setSelectedScreens([...selectedScreens, item]);
    }
    setDropdownVisible(false);
  };

  const handleDeleteItem = (screenId) => {
    setSelectedScreens(
      selectedScreens.filter((screen) => screen.screen_id !== screenId)
    );
  };

  const toggleSectionVisibility = (screenId) => {
    setVisibleSections((prevState) => ({
      ...prevState,
      [screenId]: !prevState[screenId],
    }));
  };

  const handlePermissionChange = (
    screenId,
    secId,
    permissionType,
    isChecked
  ) => {
    const updatedPermissions = {
      ...permissions,
      [screenId]: {
        ...(permissions[screenId] || {}),
        [permissionType]: isChecked,
        sections: {
          ...(permissions[screenId]?.sections || {}),
          [secId]: {
            ...(permissions[screenId]?.sections?.[secId] || {}),
            [permissionType]: isChecked,
          },
        },
      },
    };
    setPermissions(updatedPermissions);
  };

  // const handleSubmit = () => {
  //   console.log(JSON.stringify({ name, code, description, active }));
  //   setName("");
  //   setCode("");
  //   setDescription("");
  //   setActive(0);
  // };

  // const getPermissionsData = () => {
  //   let permissionsData = {
  //     name: name,
  //     code: code,
  //     description: description,
  //     screens: [],
  //   };

  //   // Iterate over the selectedScreens to include all screens and their sections
  //   selectedScreens.forEach((screen) => {
  //     let screenPermissions = permissions[screen.screen_id] || {}; // Get permissions for the screen, if any

  //     let screenData = {
  //       screen_id: screen.screen_id,

  //       permissions: {
  //         create: screenPermissions.create ? 1 : 0,
  //         read: screenPermissions.read ? 1 : 0,
  //         delete: screenPermissions.delete ? 1 : 0,
  //       },
  //       sections: screen.sections.map((section) => {
  //         // Map over sections to ensure all are included
  //         let sectionPermissions =
  //           (screenPermissions.sections &&
  //             screenPermissions.sections[section.sec_id]) ||
  //           {};
  //         return {
  //           sec_id: section.sec_id,
  //           update: sectionPermissions.view ? 1 : 0, // Include view permission, converting to 1 or 0
  //         };
  //       }),
  //     };

  //     permissionsData.screens.push(screenData);
  //   });

  //   return permissionsData;
  // };

  const getPermissionsData = () => {
    // let permissionsData = [
    //   { name: name, code: code, description: description, active: active },
    // ];
    let permissionsData = [];

    selectedScreens.forEach((screen) => {
      let screenPermissions = permissions[screen.screen_id] || {}; // Get permissions for the screen, if any

      let screenData = {
        sections: screen.sections.map((section) => {
          // Map over sections to ensure all are included
          let sectionPermissions =
            (screenPermissions.sections &&
              screenPermissions.sections[section.sec_id]) ||
            {};
          return {
            screen_id: screen.screen_id,
            wb_scr_sec_id: section.sec_id,
            create_perm: screenPermissions.create ? 1 : 0,
            read_perm: screenPermissions.read ? 1 : 0,
            delete_perm: screenPermissions.delete ? 1 : 0,
            update_perm: sectionPermissions.view ? 1 : 0, // Include view permission, converting to 1 or 0
          };
        }),
      };

      // Use spread operator to flatten the array into the permissionsData
      permissionsData.push(...screenData.sections);
    });

    return permissionsData;
  };

  const handleSavePermissions = async () => {
    const permissionsData = getPermissionsData();
    console.log(JSON.stringify(permissionsData));

    const windowReload = () => {
      window.location.reload();
    };

    if (!name || !code || !description) {
      // alert("Input fields Vacant");
      Swal.fire({
        title: "Error in creating role",
        text: "Please fill all the input fields",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    } else if (Object.keys(permissions).length === 0) {
      // alert("Insert Screens for the Role");
      Swal.fire({
        title: "Error in creating role",
        text: "Insert Screens for the Role",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    } else {
      try {
        const user_name =
          dataClient.dataClient.client_schema_name[6][0].user_name;
        const client_id =
          dataClient.dataClient.client_schema_name[6][0].client_id;
        const response = await fetch(
          // `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-role?client_id=${client_id}&role_code=${code}&role_name=${name}&role_desc=${description}d&user_name=${user_name}`,
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-role?client_id=${client_id}&role_code=${code}&role_name=${name}&role_desc=${description}&user_name=${user_name}&status=${active}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(permissionsData),
          }
        );

        console.log(active);

        if (response.ok) {
          // alert(`Role Created`);
          Swal.fire({
            title: "Role created successfully",
            // text: response.ok,
            icon: "success",
            timer: 2000, // 3 seconds
            confirmButtonColor: "#318682",
          }).then(() => {
            setTimeout(function () {
              window.location.reload();
            }, 100);
          });
        }

        if (!response.ok) {
          // throw new Error(`API request failed with status ${response.status}`);
          Swal.fire({
            title: "Error in creating role",
            text: `API request failed with status ${response.status}`,
            icon: "error",
            confirmButtonColor: "rgb(100 101 101)",
          });
        }

        const data = await response.json();
        console.log("Data created:", data);
      } catch (error) {
        console.error("Error creating data:", error);
        Swal.fire({
          title: "Error in creating data",
          // text: `${error}`,
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
        // setError(error.message);
      }

      // setName("");
      // setCode("");
      // setDescription("");
      // setActive(0);
      // window.location.reload();
      // Optionally, send the permissionsData to a backend server via an API call
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Cancelled", "Your changes have been cancelled.", "success");
        window.location.reload();
      }
    });
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Create Role</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSavePermissions}>
            CREATE
          </button>
        </div>
      </div>

      <div className="create-role-container-two">
        <div className="create-role-container-two-one">
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <p className="cr-margin-bottom">Name</p>
                <div>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="create-role-name-field"
                    style={{ padding: "10px", outline: "none" }}
                  />
                </div>
              </div>
              <div>
                <p className="cr-margin-bottom">Code</p>
                <div>
                  <input
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="create-role-code-field"
                    style={{ padding: "10px", outline: "none" }}
                  />
                </div>
              </div>
            </div>

            <div>
              <p className="cr-margin-bottom" style={{ marginTop: "10px" }}>
                Description
              </p>
              <div>
                {/* <input type="text" style={{ width: "100%", height: "10vh" }} /> */}
                {/* <textarea name="" id="" cols="84" rows="10"></textarea> */}
                <textarea
                  // style={{ width: "100%", height: "10vh" }}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                  className="create-role-description-field"
                  style={{ padding: "10px", outline: "none" }}
                ></textarea>
              </div>
            </div>
          </div>

          <div>
            <div>
              <p className="cr-margin-bottom">Active</p>
              <label className="cr-switch">
                <input
                  type="checkbox"
                  name="active"
                  checked={active === 1} // This ensures the checkbox is checked based on 'active' state
                  onChange={(e) => {
                    setActive(e.target.checked ? 1 : 0); // Toggle 'active' between 1 and 0
                  }}
                />
                <span className="cr-slider cr-round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div>
        {/* <div>
          <span>Add Screen</span>
          <SearchComponent />
        </div> */}

        <div
          style={{ marginTop: "20px" }}
          // ref={dropdownRef}
        >
          <p className="cr-margin-bottom">Add Screen</p>

          {/* Search component */}
          <div className="cr-screens-container">
            <div className="cr-screen-search-container">
              <input
                type="text"
                placeholder="Type here to search"
                value={searchText}
                onChange={(e) => {
                  // setSearchText(e.target.value);
                  // const filteredResults = dataTwo.filter((item) =>
                  //   item.screen_name
                  //     .toLowerCase()
                  //     .includes(searchText.toLowerCase())
                  // );
                  // setSearchResults(filteredResults);
                  // setDropdownVisible(true);
                  const currentSearchText = e.target.value;
                  setSearchText(currentSearchText); // Update searchText state

                  if (currentSearchText.trim() === "") {
                    setDropdownVisible(false); 
                    setSearchResults([]); 
                  } else {
                    const filteredResults = data.filter(
                      (item) =>
                        item.screen_name
                          .toLowerCase()
                          .includes(currentSearchText.toLowerCase()) 
                    );
                    setSearchResults(filteredResults);

                    setDropdownVisible(filteredResults.length > 0); 
                  }
                }}
                // ref={dropdownRef}
                // onFocus={() => setDropdownVisible(true)}
                className="cr-add-screen-input"
              />
              <button className="cr-add-screen-button" onClick={handleSearch}>
                <img
                  src={search}
                  alt="search icon"
                  style={{ width: "90%", height: "100%" }}
                />
              </button>
            </div>
            {dropdownVisible && (
              <ul
                className="cr-screen-dropdown"
                style={{ maxHeight: `120px`, overflowY: "auto" }}
                ref={dropdownRef}
              >
                {searchResults.map((item) => (
                  <li
                    key={item.screen_id}
                    onClick={() => handleSelectItem(item)}
                    // ref={dropdownRef}
                  >
                    {item.screen_name}
                  </li>
                ))}
              </ul>
            )}

            <div>
              {selectedScreens.map((screen) => (
                <div key={screen.screen_id} className="cr-selected-screen">
                  <div
                    className="cr-screen-header"
                    style={{ boxShadow: "4px 4px 4px lightgray" }}
                  >
                    <span>{screen.screen_name}</span>
                    <button onClick={() => handleDeleteItem(screen.screen_id)}>
                      {/* Delete */}
                      <img src={bin} alt="" />
                    </button>
                  </div>

                  <div className="cr-permissions">
                    <div className="cr-crud-permissions">
                      <button
                        onClick={() =>
                          toggleSectionVisibility(screen.screen_id)
                        }
                      >
                        {visibleSections[screen.screen_id] ? "-" : "+"}
                      </button>
                      Edit
                      <label className="cr-display-flex">
                        <input
                          type="checkbox"
                          className="cr-custom-checkbox"
                          checked={
                            permissions[screen.screen_id]?.create || false
                          }
                          onChange={(e) =>
                            handlePermissionChange(
                              screen.screen_id,
                              null, // No specific section ID for screen-level permissions
                              "create",
                              e.target.checked
                            )
                          }
                        />
                        Create
                      </label>
                      <label className="cr-display-flex">
                        <input
                          type="checkbox"
                          checked={permissions[screen.screen_id]?.read || false}
                          className="cr-custom-checkbox"
                          onChange={(e) =>
                            handlePermissionChange(
                              screen.screen_id,
                              null, // No specific section ID for screen-level permissions
                              "read",
                              e.target.checked
                            )
                          }
                        />
                        Read
                      </label>
                      <label className="cr-display-flex">
                        <input
                          type="checkbox"
                          checked={
                            permissions[screen.screen_id]?.delete || false
                          }
                          className="cr-custom-checkbox"
                          onChange={(e) =>
                            handlePermissionChange(
                              screen.screen_id,
                              null, // No specific section ID for screen-level permissions
                              "delete",
                              e.target.checked
                            )
                          }
                        />
                        Delete
                      </label>
                    </div>
                  </div>

                  {visibleSections[screen.screen_id] && (
                    <div className="cr-screen-sections">
                      <p style={{ marginBottom: "20px" }}>
                        Select the sections that can be edited by the role
                      </p>
                      {screen.sections.map((section) => (
                        <div key={section.sec_id} className="cr-section">
                          <label className="cr-display-flex">
                            <input
                              type="checkbox"
                              className="cr-custom-checkbox"
                              checked={
                                permissions[screen.screen_id]?.sections?.[
                                  section.sec_id
                                ]?.view || false
                              }
                              onChange={(e) =>
                                handlePermissionChange(
                                  screen.screen_id,
                                  section.sec_id,
                                  "view",
                                  e.target.checked
                                )
                              }
                            />
                            <span
                              style={{
                                marginLeft: "20px",
                                textTransform: "uppercase",
                              }}
                            >
                              {section.sec_name}
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateRole;

// ========================================================================

// import React, { useState } from 'react';

// function ButtonOutside() {
//   const [name, setName] = useState('');
//   const [salary, setSalary] = useState('');
//   const [age, setAge] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const handleSubmit = async (event) => {
//     event.preventDefault(); // Prevent default form submission behavior (not strictly necessary here)

//     setIsLoading(true);
//     setError(null);

//     try {
//       const response = await fetch('https://dummy.restapiexample.com/api/v1/create', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ name, salary, age }),
//       });

//       if (!response.ok) {
//         throw new Error(`API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Data created:', data); // Handle successful response (optional)

//       // Clear form fields after successful submission (optional)
//       setName('');
//       setSalary('');
//       setAge('');
//     } catch (error) {
//       console.error('Error creating data:', error);
//       setError(error.message); // Set error message for display
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div>
//       <form onSubmit={handleSubmit}>
//         <label>
//           Name:
//           <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
//         </label>
//         <label>
//           Salary:
//           <input type="number" value={salary} onChange={(e) => setSalary(e.target.value)} required />
//         </label>
//         <label>
//           Age:
//           <input type="number" value={age} onChange={(e) => setAge(e.target.value)} required />
//         </label>
//       </form>
//       <button type="button" disabled={isLoading} onClick={handleSubmit}>
//         {isLoading ? 'Creating...' : 'Create'}
//       </button>
//       {error && <p className="error">{error}</p>}
//     </div>
//   );
// }

// export default ButtonOutside;
